var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { homeLoansHau } from './backups/home-loans-hau';
import { homeLoans } from './backups/home-loans';
import { dscr } from './backups/dscr';
import { dscrLoan } from './backups/dscr-loan';
export var backupConfig = __assign(__assign(__assign(__assign({}, homeLoansHau), homeLoans), dscr), dscrLoan);
export var defaultFlow = "home-loans-hau";
